import styled, { css } from "styled-components";
import { GenericButton } from "../VocabularyStyle"
import { colors } from "../../../components/01_config/Colors";
import { MainButton, MainFrame, MainInput } from "../../../components/01_config/MainStyles";

const FramesWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    gap: 7vw;
    z-index: 20;
    opacity: ${({ startTestMode, listOfWordsMode }) => startTestMode || listOfWordsMode ? "0.4" : "1"};
    @media(max-width: 1200px) {
        flex-direction: column-reverse;
        align-items: center;
    }
`

const Frame = styled(MainFrame)`
    width: 43vw;
    max-width: 500px;
    // height: 550px;
    padding: 15px 30px 40px;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    gap: 0;
    &:last-of-type {
       padding: 0px 0px 0px;
       gap: 0;
       justify-items: stretch;
    }
    @media(max-width: 1200px) {
        width: 90vw;
        max-width: 480px;
        height: fit-content;
    }
`

const CheckButton = styled(MainButton)`
    width: 24px;
    height: 24px;
    margin-right: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const disabledCheckButton = css`
  pointer-events: none;
  border-width: 0px;
  &:hover {
    font-size: 0.75rem;
    border-width: 0px;
    cursor: initial;
  }
  &:active {
    transform: translate(0, 0);
  }

  /* default disabled look */
  opacity: 0.5;
  background-color: #E3E3E3;
`;


const CheckButtonFrame = styled(CheckButton)`
  background-color: ${({ correctStudent }) => (correctStudent ? colors.green : "")};

  ${({ disabled, correctStudent }) =>
    disabled &&
    css`
      ${disabledCheckButton}
      ${correctStudent
        ? css`
            background-color: #6b6b6b; /* dark grey when checked */
            opacity: 1;
          `
        : ""}
    `}
`;


const CheckButtonFrameTutor = styled(CheckButton)`
  background-color: ${({ correctTutor }) => (correctTutor ? colors.green : "")};

  ${({ disabled, correctTutor }) =>
    disabled &&
    css`
      ${disabledCheckButton}
      ${correctTutor
        ? css`
            background-color: #6b6b6b; /* dark grey when checked */
            opacity: 1;
          `
        : ""}
    `}
`;


const CheckBoxTitleStudent = styled.div`
    // position: absolute;
    // top: 5px;
    // left: -38px;
    font-weight: bold;
`

const CheckBoxTitleTutor = styled.div`
    // position: absolute;
    // top: 5px;
    // left: 10px;
    font-weight: bold;
`

const StudentTutorLanguageWrapper = styled.div`
    width: 100%;
    display: flex;
    padding-bottom: 30px;
`

const StudentTutorWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding-left: 8px;
    width: 75px;
    line-height: 2;
    @media(max-width: 800px) {
        width: 80px;
    }    
`

const LanguageButtonsWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 15px;
    @media(max-width: 800px) {
        justify-content: right;
    }
`

const LanguageButton = styled.button`
    width: 100px;
    height: 30px;
    font-size: 0.95rem;
    font-weight: 500;
    text-transform: uppercase;
    background-color: transparent;
    border: none;
    cursor: pointer;
    &:nth-of-type(1) {
        border-bottom: ${({ language }) => language === "Eng" ? "solid black 1px" : "none"};
    }
    &:nth-of-type(2) {
        border-bottom: ${({ language }) => language === "Ukr" ? "solid black 1px" : "none"};
    }
    &:hover {
        font-weight: 600;
        border-width: 2px;
    }
    @media(max-width: 800px) {
        width: 80px;
    }
`

const InputWordWrapper = styled.div`
    flex: 1;
    position: relative;
    display: flex;
    // width: 100%;
    @media(max-width: 1200px) {
        flex-direction: column;
    }  
`

const WordWrapper = styled.div`
    line-height: 1;
    // display: flex;
    // flex-direction: column;
`

const Input = styled(MainInput)`
    width: 160px;
    margin-right: 25px;
    @media(max-width: 800px) {
        max-width: 100%;
        width: 100%;
    };
`

const Word = styled.div`
    position: relative;
    width: 100%;
    user-select: none;
    font-weight: 600;
    font-size: 1.1rem;
    display: flex;
    align-items: start;
    margin-bottom: 0;
    @media(max-width: 1200px) {
        // margin 0 auto;
        margin-top: 0px;
    };
`

const WordCheck = styled(Word)`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    text-align: left;
    height: 20px;
`

const WordSpan = styled.div`
    margin-right: 5px;
    cursor: pointer;
    &:hover {
        font-weight: 650;
    }
`

const WordSpanCheck = styled(WordSpan)`
    font-size: 1.3rem;
    cursor: default;
    flex: 1;
    &:hover {
        font-weight: 600;
    }
`

const TranslatSpan = styled.div`
    color: red;
    font-weight: 600;
    margin-bottom: 5px;
    // &:hover {
    //     font-weight: 750;
    // }
`

const LessonDivider = styled.hr`
  border: 0;
  border-top: 1px solid rgba(0,0,0,0.2);
  margin: 12px 0;
  width: 120%;
  @media(max-width: 800px) {
    width: 100%;
  }
  &before {
    content: "lesson end"
  }
`;

const LessonLabel = styled.div`
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 6px;
  margin-bottom: 2px;
  text-align: left;
`;

const LargeButtonsWrapper = styled.div`
    box-sizing: content-box;
    padding: 20px 40px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 50px;
    border-bottom: solid lightgrey 2px;
    @media(max-width: 1200px) {
        padding: 20px 5px;
    }
`

const LargeButton = styled(GenericButton)`
    // background-color: red;
    &:nth-of-type(1) {
        border: ${({ thousand }) => thousand === "First Thousand" ? `${colors.greyBoldFrame} solid 4px` : ""}
    }
    &:nth-of-type(2) {
        border: ${({ thousand }) => thousand === "Second Thousand" ? `${colors.greyBoldFrame} solid 4px` : ""}
    }
`

const NumberButtonWrapper = styled.div`
    padding: 20px 0;
    display: flex;
    flex: 1;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    border-bottom: solid lightgrey 2px;

`

// const TopButton = styled(GenericButton)`
//     width: 100px;
//     &:nth-of-type(${({ topNumber }) => topNumber ? topNumber : "1"}) {
//         border: ${colors.greyBoldFrame} solid 4px;
//     }
//     background-color: ${({ color }) => color === colors.green ? color : ""};
// `

const TopButton = styled(GenericButton)`

width: 100px;
border: gray solid 2px;
  border: ${({ selected }) => (selected ? `${colors.greyBoldFrame} solid 4px` : "gray solid 2px")};
`;


// const BottomButton = styled(GenericButton)`
//     width: 100px;
//     &:nth-of-type(${({ bottomNumber }) => bottomNumber ? bottomNumber : "1"}) {
//         border: ${colors.greyBoldFrame} solid 4px;
//     }
//     background-color: ${({ color }) => color === colors.green ? color : ""};
// `

const BottomButton = styled(GenericButton)`
  width: 100px;
  border: ${({ selected }) => (selected ? `${colors.greyBoldFrame} solid 4px` : "gray solid 2px")};
`;


const PercentButton = styled.div`
    position: relative;
    width: 100px;
    height: 35px;
    border: 2px solid ${colors.greyFrame};
    padding-left: 0;
    font-size: 0.75rem;
    font-weight: 600;
    display: flex;
`

const ProgressBarStudent = styled.div`
    position: absolute;
    height: 100%;
    width: ${({percentStudent}) => percentStudent ? `${percentStudent}%` : "0%"};
    background-color: ${colors.green};
`

const ProgressBarTutor = styled.div`
    position: absolute;
    height: 100%;
    width: ${({percentTutor}) => percentTutor ? `${percentTutor}%` : "0%"};
    background-color: ${colors.green};
`

const Percent = styled.div`
    position: relative;
    text-align: center;
    margin: auto;
`

export { FramesWrapper, Frame, CheckButton, CheckButtonFrame, CheckButtonFrameTutor, CheckBoxTitleStudent, CheckBoxTitleTutor, StudentTutorLanguageWrapper, StudentTutorWrapper, LanguageButtonsWrapper, LanguageButton, InputWordWrapper, WordWrapper, Input, Word, WordCheck, WordSpan, WordSpanCheck, TranslatSpan, LessonDivider, LessonLabel, LargeButtonsWrapper, LargeButton, NumberButtonWrapper, TopButton, BottomButton, PercentButton, ProgressBarStudent, ProgressBarTutor, Percent }


//    ${({ correctTutor }) => correctTutor ? disabledCheckButton : ""}